export default "__VITE_ASSET__BvOuGnHG__";